import Translate from "../Translate";
import PropertyViewValue, { AppPropertyType } from "./PropertyViewValue";

export type PropertyViewPropsType = {
    label?: string | React.ReactNode | false,
    value?: any,
    children?: React.ReactNode
    format?: string,
    className?: string
    propertyType?: AppPropertyType
    textSize?: 'text-sm' | 'text-lg' | 'text-md',
    labelClassName?: string
}

const PropertyView = (props: PropertyViewPropsType) => {
    let value = props.value ? <PropertyViewValue value={props.value} propertyType={props.propertyType} /> : props.children;

    let label:any = <></>;
    if (typeof props.label == 'string' && props.label) {
        label = <div className={`font-bold text-sm pb-1 app-label ${props.labelClassName || ''}`}>
            <Translate i18nKey={props.label} />:
        </div>;
    }

    if(typeof props.label == 'object') {
        label = props.label;
    }

    const getClassName = () => {
        let classes = [
            'property-view',
            'py-2',
            props.textSize || 'text-lg'
        ];

        if(props.className) {
            classes.push(props.className);
        }

        return classes.join(' ');
    }

    return (
        <div className={getClassName()}>
            {label}
            <div className="overflow-hidden text-ellipsis whitespace-nowrap">
                {value}
            </div>
        </div>
    );
}

export default PropertyView;
